import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';

type TrailerBottomPaginationProps = {
  page: number;
  total: number;
  totalRows: number;
  onPageChange: (page: number) => void;
};

const TrailerBottomPagination: React.FC<TrailerBottomPaginationProps> = ({
  page,
  total,
  totalRows,
  onPageChange,
}) => {
  return (
    <Box
      sx={{
        mt: 2,
        px: 2,
        py: { sm: 0.5, md: 1 },
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: { xs: 'row', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: { sm: 1, md: 2 },
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Trailers: {totalRows}
      </Typography>

      <Pagination
        page={page}
        count={total}
        color="primary"
        onChange={(_, value) => onPageChange(value)}
      />
    </Box>
  );
};

export default TrailerBottomPagination;